import { useContext } from 'react';
import ModalContext from '~/context/vdp/ModalContext';
import useIsInJumpStartExperiment from './useIsInJumpStartExperiment';

// A placeholder over an open modal would stack two modals.
export default function useShowAccountModalPlaceholder() {
  const { isAnyModalOpen } = useContext(ModalContext);
  const isInJumpStartExperiment = useIsInJumpStartExperiment();

  return isInJumpStartExperiment && !isAnyModalOpen;
}
